import { Type } from '@angular/core';
import { subclass } from '@arcgis/core/core/accessorSupport/decorators';
import { JepVectorTileLayer, ThemeColor, JepToolsMixin } from '@jeppesen-foreflight/jmkw-types';
import { TwcLayerInterface, TwcMixin } from '../../twc.mixin';

// Only need to define vector-tile specific interfaces and types
export interface VectorStyle {
  layers: VectorStyleLayer[];
  sources?: Record<string, { url: string; type: string }>;
  glyphs?: string | (() => string);
  sprite?: string | (() => string);
}

export interface VectorStyleLayer {
  layout?: Record<string, any>;
  paint?: Record<string, any>;
  source: string;
  custom?: {
    basemapShade?: 'light' | 'dark';
  };
  minzoom?: number;
  'source-layer': string;
  id: string;
  filter: any[];
  type:
    | 'fill'
    | 'line'
    | 'symbol'
    | 'circle'
    | 'heatmap'
    | 'fill-extrusion'
    | 'raster'
    | 'hillshade'
    | 'background';
  maxzoom?: number;
  'symbol-placement'?: string;
}

// Define an extended jepTools type
export type TwcVectorTileLayerJepTools = {
  toggleVectorStyleColor(basemapColor?: ThemeColor): void;
};

@subclass('jmkw.layers.TwcVectorTileLayer')
export class TwcVectorTileLayer extends JepToolsMixin<
  Type<JepVectorTileLayer & TwcLayerInterface>,
  TwcVectorTileLayerJepTools
>(TwcMixin<Type<JepVectorTileLayer>>(JepVectorTileLayer), {
  toggleVectorStyleColor(
    this: TwcVectorTileLayer,
    basemapColor: ThemeColor
  ): void {
    const basemapRegex = new RegExp(basemapColor);

    const style = this.currentStyleInfo?.style;
    if (style?.sprite) {
      style.layers.forEach((vectorStyleLayer: VectorStyleLayer) => {
        if (
          vectorStyleLayer.layout &&
          'icon-image' in vectorStyleLayer.layout
        ) {
          if (vectorStyleLayer.custom?.basemapShade) {
            this.setStyleLayerVisibility(
              vectorStyleLayer.id,
              basemapRegex.test(vectorStyleLayer.custom.basemapShade)
                ? 'visible'
                : 'none'
            );
          }
        }
      });
    }
  }
}) {}
